import { Reveal } from "../Reveal";
import { useLang } from "@/i18n";

const Section = ({ title, children }) => (
  <Reveal>
    <div className="border-t border-[#1A1B18]/10 pt-8">
      <h2 className="font-modern text-xl md:text-2xl font-medium tracking-tight mb-4">{title}</h2>
      <div className="text-sm md:text-base text-[#1A1B18]/70 leading-relaxed space-y-3">{children}</div>
    </div>
  </Reveal>
);

export default function Cookie() {
  const { lang } = useLang();
  return (
    <div className="v2-modern bg-[#FAF9F6] text-[#1A1B18] min-h-screen" data-testid="cookie-page">
      <header className="border-b border-[#1A1B18]/10">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <a href="/" data-testid="cookie-logo" className="font-modern text-xl md:text-2xl font-semibold tracking-tight">
            Stylottica Ceglie
          </a>
          <a
            href="/"
            data-testid="cookie-back"
            className="rounded-full border border-[#1A1B18]/30 text-[10px] uppercase tracking-[0.15em] px-4 py-2 hover:bg-[#1A1B18] hover:text-white transition-colors duration-300"
          >
            {lang === "it" ? "Torna al sito" : "Back to site"}
          </a>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16 md:py-24">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#A86946] mb-4">Cookie</p>
          <h1 className="font-modern text-4xl md:text-6xl font-medium tracking-tighter leading-[1.05] mb-6">
            Cookie Policy
          </h1>
          <p className="text-sm text-[#1A1B18]/50 mb-14">
            Ultimo aggiornamento: luglio 2026 · ai sensi delle Linee guida del Garante per la protezione dei dati personali
          </p>
        </Reveal>

        <div className="space-y-10">
          <Section title="1. Cosa sono i cookie">
            <p>
              I cookie sono piccoli file di testo che i siti visitati salvano sul dispositivo dell'utente. Servono a far
              funzionare il sito, a ricordare alcune preferenze o a raccogliere informazioni statistiche.
            </p>
          </Section>

          <Section title="2. Cookie utilizzati da questo sito">
            <p>
              Questo sito utilizza <strong>esclusivamente cookie tecnici e di preferenza</strong>, necessari al corretto
              funzionamento e non soggetti a consenso preventivo:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>preferenza della lingua scelta (IT/EN/DE/FR);</li>
              <li>gestione del carrello e della sessione di navigazione;</li>
              <li>parametri tecnici necessari alla sicurezza e alla stabilità del sito.</li>
            </ul>
            <p>
              <strong>Non</strong> utilizziamo cookie di profilazione, pubblicitari o di tracciamento di terze parti. I font
              tipografici sono serviti direttamente dai nostri server, senza trasferimento di dati a fornitori esterni.
            </p>
          </Section>

          <Section title="3. Strumenti statistici / di terze parti">
            <p>
              Attualmente il sito non utilizza strumenti di analisi statistica (es. Google Analytics) né plugin social che
              installino cookie. Qualora in futuro venissero introdotti strumenti di questo tipo, la presente informativa
              verrà aggiornata e verrà mostrato un banner per la raccolta del consenso, come richiesto dal Garante.
            </p>
          </Section>

          <Section title="4. Come gestire o disabilitare i cookie">
            <p>
              L'utente può gestire o eliminare i cookie tramite le impostazioni del proprio browser (Chrome, Safari, Firefox,
              Edge). La disabilitazione dei cookie tecnici potrebbe compromettere alcune funzionalità del sito.
            </p>
          </Section>

          <Section title="5. Titolare del trattamento">
            <p>
              Il titolare del trattamento è <strong>Stylottica &amp; C. s.a.s.</strong> (insegna <strong>Stylottica Ceglie</strong>),
              con sede in Via Cristoforo Colombo 40, 72013 Ceglie Messapica (BR), P.IVA 02325720742.
            </p>
            <p>
              Per informazioni scrivi a{" "}
              <a href="mailto:infostylottica@libero.it" className="text-[#A86946] underline underline-offset-2">
                infostylottica@libero.it
              </a>{" "}
              o consulta la{" "}
              <a href="/privacy" className="text-[#A86946] underline underline-offset-2">
                informativa privacy
              </a>
              .
            </p>
          </Section>
        </div>
      </main>
    </div>
  );
}
